import { render, staticRenderFns } from "./InfoLabels.vue?vue&type=template&id=0b48b5de&scoped=true"
import script from "./InfoLabels.vue?vue&type=script&lang=js"
export * from "./InfoLabels.vue?vue&type=script&lang=js"
import style0 from "./InfoLabels.vue?vue&type=style&index=0&id=0b48b5de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b48b5de",
  null
  
)

export default component.exports